import { Skeleton as e } from "../Primitives/Skeleton.mjs";
import "react";
import { styled as t } from "styled-components";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/MetricHeadline/MetricHeadline.tsx
var i = t.div`
    display: flex;
    align-items: baseline;
    gap: ${({ theme: e }) => e.spacing(1)};
    margin-bottom: ${({ theme: e }) => e.spacing(1)};
`, a = t.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes["3xl"]};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.bold};
    color: ${({ theme: e }) => e.colors.foreground};
`, o = t.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
`, s = ({ value: t, label: s, loading: c, className: l }) => /* @__PURE__ */ r(i, {
	className: l,
	children: [c ? /* @__PURE__ */ n(e, {
		width: 120,
		height: 32
	}) : /* @__PURE__ */ n(a, { children: t }), s ? /* @__PURE__ */ n(o, { children: s }) : null]
});
//#endregion
export { s as MetricHeadline };
